export const translationUploadData_da_part4 = {
  uploadFailedUserNotFound: "Upload fejlede: Valgt bruger ikke fundet. Genindlæs og prøv igen.",
  uploadFailedMissingFields: "Upload fejlede: Manglende påkrævet information. Udfyld alle felter.",
  uploadFailedAuthError: "Upload fejlede: Bruger-godkendelsesfejl. Log ind igen.",
  uploadFailedNetwork:
    "Upload fejlede: Netværksforbindelsesproblem. Tjek din forbindelse og prøv igen.",
  uploadFailedTimeout: "Upload timed out. Prøv igen eller reducer upload størrelse.",
  uploadFailedAuthExpired: "Upload fejlede: Godkendelse udløbet. Log ind igen.",
  uploadFailedServerError: "Fejl: Kontakt Diverge.",
  uploadFailedGeneric: "Fejl: Kontakt Diverge: {error}",
  contentMayNeedChunking:
    "Advarsel: Indholdet er estimeret til {tokens} tokens, hvilket kan kræve opdeling for behandling. Overvej at opdele i mindre sektioner hvis upload fejler.",
  pleaseSelectUser: "Vælg venligst en bruger.",
  pleaseSelectOrganization: "Vælg venligst en organisation.",
  pleaseSelectOrganizationToManage: "Vælg venligst en organisation for at administrere deres data",
  selectOrganization: "Vælg Organisation",
  selectOrganizationPlaceholder: "Vælg organisation",
  noDataFoundForOrganization: "Ingen data fundet for {name}",
  errorFetchingOrganizations: "Fejl ved hentning af organisationer",
  // Additional error and UI messages
  // Additional error and UI messages
  authTokenNotFound: "Godkendelsestoken ikke fundet.",
  errorFetchingUsers: "Fejl ved hentning af brugere",
  errorFetchingUserIndexes: "Fejl ved hentning af brugerens vidensbase-indekser",
  noTextContentFound: "Ingen tekstindhold fundet i PDF",
  errorExtractingPdfText: "Fejl ved udtrækning af tekst fra PDF. Prøv igen.",
  selectAccessibleUser: "Vælg Tilgængelig Bruger",
  selectAccessibleUserPlaceholder: "Vælg tilgængelig bruger",
  selectUser: "Vælg Bruger",
  selectUserToManage: "Vælg Bruger at Administrere",
  selectUserToManagePlaceholder: "Vælg bruger at administrere",
  noMatchingResults: "Ingen matchende resultater fundet",
  noDataFoundForUser: "Ingen data fundet for {username}",
  noDataFound: "Ingen data fundet",
  pleaseSelectUserBase: "Vælg venligst en bruger",
  fromAccessibleUsers: "fra dine tilgængelige brugere",
  toManageTheirData: "for at administrere deres data",
  // Text chunking translations
  // Text chunking translations
  textChunkingWarningTitle: "Tekst kræver opdeling",
  textChunkingWarningMessage:
    "Din tekst er {chars} tegn lang og overstiger grænsen på 25.000 tegn. Du har to muligheder:",
  textChunkingAutoOption: "Automatisk opdeling",
  textChunkingAutoDescription:
    "Systemet vil automatisk opdele din tekst i {chunks} meningsfulde dele med 10% overlap.",
  textChunkingManualOption: "Opdel selv",
  textChunkingManualDescription: "Gå tilbage og opdel teksten i mindre sektioner manuelt.",
  textChunkingProceed: "Opdel automatisk",
  textChunkingGoBack: "Gå tilbage",
  textChunkingInProgress: "Opdeler tekst...",
  textChunkUploadNote: "Hver del vil blive uploadet som en separat, søgbar post",
  // Folder management translations
  // Folder management translations
  createFolder: "Opret Mappe",
  createNewFolder: "Opret Ny Mappe",
  folderName: "Mappenavn",
  enterFolderName: "Indtast mappenavn",
  parentFolder: "Overordnet Mappe",
  selectParentFolder: "Vælg overordnet mappe",
  rootNoFolder: "Rod (Ingen Mappe)",
  uploadToFolder: "Upload til Mappe",
  selectFolder: "Vælg mappe",
  folderNameRequired: "Mappenavn er påkrævet",
  folderCreatedSuccessfully: "Mappe oprettet succesfuldt",
  errorCreatingFolder: "Fejl ved oprettelse af mappe",
  creatingFolder: "Opretter...",
  uploadToThisFolder: "Upload til denne mappe",
  entryMovedToFolder: "Element flyttet til mappen",
  entryMovedToRoot: "Element flyttet til roden",
  errorMovingEntryToFolder: "Kunne ikke flytte element til mappen",
  dragToMove: "Træk for at flytte",
  noIndexesAvailable: "Ingen vidensbaser tilgængelige",
  retry: "Prøv igen",
  numberOfChunks: "Antal chunks",
  renameFolder: "Omdøb Mappe",
  renameFolderButton: "Omdøb",
  renamingFolder: "Omdøber...",
  folderRenamedSuccessfully: "Mappe omdøbt",
  errorRenamingFolder: "Fejl ved omdøbning",
  changesSavedSuccessfully: "Ændringer gemt",
  allInformationChunksLoaded: "Alle info chunks er indlæst",
  itemCreatedOn: "Oprettet {date}",
  itemEditedOn: "Redigeret {date}",
  viewHistory: "Vis historik",
};
